module.exports = __webpack_public_path__ + "img/faneam-grande.4cb95c4b.png";